<template lang="pug">
  .input_percentage
    input-text(
      :id="inputKey"
      :prefix="prefix"
      :suffix="suffix"
      :label="label"
      v-model="valueData"
      :disabled="disabled"
      :style="getPrefixColor"
      :maxlength="maxlength"
      :required="required"
      :rules="rules"
      :decimals="decimals"
      @input="formatNumber($event)"
      @keypress="onlyNumber($event)"
    )
</template>

<script>
import InputMoneyAndPercentageMixin from 'Support/mixins/InputMoneyAndPercentageMixin';

export default {
  name: 'InputPercentage',
  mixins: [InputMoneyAndPercentageMixin],
  props: {
    label: {
      type: String,
      default: 'Input percentage',
    },
    suffix: {
      type: String,
      default: '%',
    },
  },
  methods: {
    replaceNumber(value) {
      let v = value.toString();
      v = v.replace(/^00+/, '');
      v = v.replace(/\D/g, '');

      const regexp = new RegExp(`(\\d{1,${this.decimals}})$`);
      return v.replace(regexp, `${this.separator}$1`);
    },
  },
};
</script>
<style lang="stylus">
  .input_percentage
    .v-text-field--outline .v-text-field__prefix
      margin-top 0
</style>
